import { render } from "./KPIAdmin.vue?vue&type=template&id=4048b678&scoped=true&ts=true"
import script from "./KPIAdmin.vue?vue&type=script&lang=ts"
export * from "./KPIAdmin.vue?vue&type=script&lang=ts"

import "./KPIAdmin.vue?vue&type=style&index=0&id=4048b678&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4048b678"]])

export default __exports__